(function () {
  var root = document.querySelector('[data-nr-leave-review]');
  if (!root) return;

  var form = root.querySelector('[data-nr-leave-form]');
  var steps = Array.prototype.slice.call(root.querySelectorAll('[data-nr-step]'));
  var actions = root.querySelector('[data-nr-actions]');
  var nextButton = root.querySelector('[data-nr-next]');
  var backButton = root.querySelector('[data-nr-back]');
  var errorBanner = root.querySelector('[data-nr-error]');
  var thanks = root.querySelector('[data-nr-thanks]');
  var chosen = root.querySelector('[data-nr-chosen]');
  var chosenStars = root.querySelector('[data-nr-chosen-stars]');
  var chosenLabel = root.querySelector('[data-nr-chosen-label]');
  var starButtons = Array.prototype.slice.call(root.querySelectorAll('[data-nr-star]'));
  var nameInput = root.querySelector('[data-nr-name]');
  var productSelect = root.querySelector('[data-nr-product]');
  var messageInput = root.querySelector('[data-nr-message]');
  var emailInput = root.querySelector('[data-nr-email]');
  var order = ['stars', 'name', 'product', 'message', 'email'];
  var continueLabel = nextButton ? nextButton.textContent.trim() : 'Continue';
  var submitLabel = 'Submit';
  var index = 0;
  var rating = 0;
  var submitting = false;
  var started = false;
  var submitUrl = 'https://reservenothing.vercel.app/api/reviews/submit';
  var successMessage = root.dataset.nrSuccessMessage || 'Thank you — we got your review.';
  var errorMessage = root.dataset.nrErrorMessage || 'Something went wrong. Please try again.';

  function stepName() {
    return order[index];
  }

  function paintStars(value) {
    starButtons.forEach(function (button) {
      var star = Number(button.getAttribute('data-nr-star'));
      var on = star <= value;
      button.classList.toggle('is-on', on);
      button.setAttribute('aria-checked', star === value ? 'true' : 'false');
    });
  }

  function showChosen() {
    if (!chosen || !chosenStars) return;
    if (!rating) {
      chosen.hidden = true;
      return;
    }
    chosenStars.textContent = '★★★★★'.slice(0, rating);
    if (chosenLabel) chosenLabel.textContent = rating + ' out of 5 stars';
    chosen.hidden = stepName() === 'stars';
  }

  function showError(message) {
    if (!errorBanner) return;
    errorBanner.textContent = message;
    errorBanner.hidden = !message;
  }

  function focusStep() {
    var step = root.querySelector('[data-nr-step="' + stepName() + '"]');
    if (!step) return;
    var field = step.querySelector('input, select, textarea, button');
    if (field) window.setTimeout(function () { field.focus({ preventScroll: true }); }, 40);
  }

  function render() {
    var name = stepName();
    steps.forEach(function (step) {
      step.hidden = step.getAttribute('data-nr-step') !== name;
    });
    if (actions) actions.classList.toggle('is-waiting', name === 'stars');
    if (nextButton) {
      var finishing = name === 'email' || (name === 'message' && messageFinishes());
      nextButton.textContent = finishing ? submitLabel : continueLabel;
    }
    showChosen();
    showError('');
    if (started) focusStep();
  }

  function goTo(name) {
    var nextIndex = order.indexOf(name);
    if (nextIndex < 0) return;
    index = nextIndex;
    render();
  }

  function currentValueOk() {
    var name = stepName();
    if (name === 'name') return nameInput && nameInput.value.trim().length > 0;
    if (name === 'product') return productSelect && productSelect.value.trim().length > 0;
    if (name === 'message') return messageInput && messageInput.value.trim().length > 0;
    if (name === 'email') return emailInput && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailInput.value.trim());
    return true;
  }

  function advance() {
    if (!currentValueOk()) {
      showError('Please answer this one to continue.');
      focusStep();
      return;
    }
    if (stepName() === 'email' || (stepName() === 'message' && messageFinishes())) {
      submitReview();
      return;
    }
    goTo(order[index + 1]);
  }

  function emailOk(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((value || '').trim());
  }

  function nextStep() {
    if (!nameInput || !nameInput.value.trim()) return 'name';
    if (!productSelect || !productSelect.value.trim()) return 'product';
    return 'message';
  }

  function messageFinishes() {
    return emailInput && emailOk(emailInput.value);
  }

  function selectRating(value) {
    rating = value;
    paintStars(value);
    window.setTimeout(function () {
      if (stepName() === 'stars') goTo(nextStep());
    }, 160);
  }

  function preselectProduct(query) {
    if (!productSelect || !query) return;
    var needle = query.trim().toLowerCase();
    var options = Array.prototype.slice.call(productSelect.options);
    var match = options.find(function (option) {
      return option.value.toLowerCase() === needle || option.textContent.trim().toLowerCase() === needle;
    });
    if (match) productSelect.value = match.value;
  }

  function scrollToForm() {
    var top = root.getBoundingClientRect().top + window.scrollY;
    window.scrollTo(0, Math.max(0, top));
  }

  function settleOnForm() {
    var attempt = 0;
    function place() {
      scrollToForm();
      attempt += 1;
      if (attempt < 6) window.setTimeout(place, 200);
    }
    place();
  }

  function readLink() {
    var params = new URLSearchParams(window.location.search);
    var linkedName = (params.get('name') || '').trim();
    var linkedEmail = (params.get('email') || '').trim();
    if (nameInput && linkedName) nameInput.value = linkedName;
    if (emailInput && emailOk(linkedEmail)) emailInput.value = linkedEmail;
    preselectProduct(params.get('product') || '');
    var linked = Number(params.get('rating') || '');
    var fromRatingLink = Number.isInteger(linked) && linked >= 1 && linked <= 5;
    if (fromRatingLink) {
      rating = linked;
      paintStars(linked);
      goTo(nextStep());
    } else {
      render();
    }
    started = true;
    if (fromRatingLink || window.location.hash === '#leave-a-review') {
      settleOnForm();
      window.addEventListener('load', settleOnForm, { once: true });
    }
  }

  function submitReview() {
    if (submitting || !form) return;
    var option = productSelect && productSelect.selectedOptions ? productSelect.selectedOptions[0] : null;
    var payload = {
      name: nameInput ? nameInput.value.trim() : '',
      email: emailInput ? emailInput.value.trim() : '',
      product: productSelect ? productSelect.value.trim() : '',
      product_title: option ? option.textContent.trim() : '',
      rating: String(rating),
      message: messageInput ? messageInput.value.trim() : '',
      website: (form.querySelector('[name="website"]') || {}).value || '',
    };

    submitting = true;
    if (nextButton) nextButton.disabled = true;
    showError('');

    fetch(submitUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })
      .then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (data) {
          if (!response.ok || !data.ok) throw new Error(data.error || errorMessage);
          if (form) form.hidden = true;
          if (chosen) chosen.hidden = true;
          if (thanks) {
            thanks.textContent = successMessage;
            thanks.hidden = false;
          }
        });
      })
      .catch(function (error) {
        showError(error.message || errorMessage);
        submitting = false;
        if (nextButton) nextButton.disabled = false;
      });
  }

  starButtons.forEach(function (button) {
    button.addEventListener('mouseenter', function () {
      paintStars(Number(button.getAttribute('data-nr-star')));
    });
    button.addEventListener('click', function () {
      selectRating(Number(button.getAttribute('data-nr-star')));
    });
  });

  var starRow = root.querySelector('[data-nr-step="stars"] .nr-leave-review__stars');
  if (starRow) {
    starRow.addEventListener('mouseleave', function () {
      paintStars(rating);
    });
  }

  if (nextButton) nextButton.addEventListener('click', advance);
  if (backButton) {
    backButton.addEventListener('click', function () {
      if (index > 0) goTo(order[index - 1]);
    });
  }

  form.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' || event.target.tagName === 'TEXTAREA') return;
    if (stepName() === 'stars') return;
    event.preventDefault();
    advance();
  });

  readLink();
})();
